import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * ORDERS notification formatter
 * Extends notification with a link to the order detail page.
 * Payload is expected to carry: { id, firstname, lastname, email, phone?, total?, currencyCode?, createdAt }.
 */
export default class OrdersFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const id = payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (payload?.total !== null && payload?.currencyCode) {
      additionalParams.push({
        key: 'order_total',
        values: { total: payload.total, currencyCode: payload.currencyCode }
      })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/orders/${id}` : undefined
    }
  }
}
